/**
 * search form component pattern for all search forms inspired by watabi forms structure
 *
 */
import {Component, Input, Output, EventEmitter} from '@angular/core';

import {Yii} from "libraries/interfaces/Yii";


@Component({
    selector: 'ui-search-form',
    template: `
        <div class="createFormContainer sequenceCreateForm">
            <div class="createFormHeader">
                <form class="sequenceSearchContainer">
                    <ng-content select=".sequenceSearchField"></ng-content>
                    <div class="buttonGroup buttonGroup-endPosition">
                        <ng-content select=".plainButton.searchActionButton"></ng-content>
                    </div>
                </form>

                <!-- manual creation block -->
                <div class="manualSequenceContainer">
      <span class="categoryCase">
      <ng-content select=".categoryTogglerContainer"></ng-content>
      </span>
                    <div class="blockDetailsContainer">
                        <ng-content select=".detailItem.detailListButton"></ng-content>
                    </div>
                </div>
            </div>
            <div class="sequenceResultsContainer globalResultContainer">

                <ng-content select=".resultContainer"></ng-content>

            </div>
        </div>
        <ng-content select=".loadMoreContainer"></ng-content>
    `
})

export class SearchFormComponent {

    // translated strings :

    public t_noResults = Yii.t('wui-shared-js', 'Aucun résultat trouvé');
    public t_seeMore = Yii.t('wui-shared-js', 'En voir plus');
    public t_close = Yii.t('wui-shared-js', 'Fermer');

}
